import React from "react";
import { CiSearch } from "react-icons/ci";
import { IoMdEye } from "react-icons/io";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import Pagination from "../../../../components/common/Pagination";
import { useTranslation } from "../../../../hooks/useTranslation";
import { BiMessageSquareDetail } from "react-icons/bi";

const Hotelfeedback = ({
  reviews,
  pagination,
  isLoading,
  isError,
  error,
  setPage,
  searchQuery,
  setSearchQuery,
  onViewReview,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="md:mt-[31px] mt-[10px]">
        <div className="rounded-[10px] breview breview-[#D9D9D9] overflow-hidden mt-[28px] py-[20px] sm:px-[30px] px-[15px] bg-white">
          <div className="flex justify-between items-center py-[13px] flex-wrap  gap-[10px]">
            <h2 className="text-base font-semibold">
              {t("hotelFeedback").title}
            </h2>
            <div className="relative w-full max-w-[301px]">
              <span className="absolute inset-y-0 left-3 flex items-center">
                <CiSearch size={24} className="text-[#4CAF50]" />
              </span>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t("hotelFeedback").searchPlaceholder}
                className="w-full pl-10 pr-4 py-2 rounded-full breview breview-[#DDDDDD] focus:outline-none focus:breview-[#4CAF50]"
              />
            </div>
          </div>

          <div className="overflow-x-auto md:mt-[30px] mt-[10px]">
            {isLoading ? (
              <div className="flex justify-center py-12">
                <div className="w-12 h-12 breview-4 breview-green-500 breview-t-transparent rounded-full animate-spin" />
              </div>
            ) : isError ? (
              <p className="text-red-500 text-center mt-6">{error.message}</p>
            ) : (
              <div className="overflow-x-auto md:mt-[30px] mt-[20px]">
                <table className="min-w-full  ">
                  <thead className="bg-[#FFFAF2] ">
                    <tr className="">
                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                        {t("hotelFeedback").columns.requestId}
                      </th>
                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                        {t("hotelFeedback").columns.guestName}
                      </th>
                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                        {t("hotelFeedback").columns.bookingId}
                      </th>

                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                        {t("hotelFeedback").columns.review}
                      </th>
                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] max-w-[197px]">
                        {t("hotelFeedback").columns.reviewSummary}
                      </th>

                      <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                        {t("hotelFeedback").columns.actions}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviews?.length > 0 ? (
                      reviews?.map((review) => {
                        return (
                          <tr className="breview-t breview-[#E4E4E4] ">
                            <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                              {review?._id}
                            </td>
                            <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                              {review?.userId?.name}
                            </td>
                            <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                              {review?.bookingId
                                ? review?.bookingId
                                : review?.orderId}
                            </td>

                            <td className="py-[20px] px-[16px]">
                              <div className="flex items-center gap-[8px]">
                                <div className="flex items-center w-auto">
                                  {Array(Math.floor(review?.rating))
                                    .fill()
                                    .map((_, index) => (
                                      <MdStar
                                        key={`full-${index}`}
                                        size={21}
                                        className="text-[#FF9D00]"
                                      />
                                    ))}

                                  {review?.rating % 1 !== 0 && (
                                    <MdStarHalf
                                      size={21}
                                      className="text-[#FF9D00]"
                                    />
                                  )}

                                  {Array(5 - Math.ceil(review?.rating))
                                    .fill()
                                    .map((_, index) => (
                                      <MdStarOutline
                                        key={`empty-${index}`}
                                        size={21}
                                        className="text-[#FF9D00]"
                                      />
                                    ))}
                                </div>

                                <p className="text-sm font-medium text-[#4CAF50]">
                                  ({review?.rating}/5)
                                </p>
                              </div>
                            </td>

                            <td className="py-[20px] px-[16px] text-base text-black  whitespace-nowrap">
                              {review?.comment}
                            </td>

                            <td className="py-[20px] px-[16px]">
                              <button
                                onClick={() => onViewReview && onViewReview(review?._id)}
                                className="text-black font-normal w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#F2F2F2] hover:bg-[#E0E0E0] transition-colors cursor-pointer"
                                type="button"
                              >
                                <IoMdEye className="text-base text-black" />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6">
                          <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
                            <div className="w-14 h-14 rounded-full bg-[#E7F4ED] flex items-center justify-center mb-4">
                              <BiMessageSquareDetail className="text-[#4CAF50] text-2xl" />
                            </div>
                            <p className="text-lg font-semibold text-[#111827]">
                              {t("hotelFeedback").noResults}
                            </p>
                            <p className="text-sm text-[#6B7280] mt-2 max-w-[360px]">
                              {t("hotelFeedback").emptyHint ||
                                "Try adjusting filters or search with another keyword."}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            {reviews?.length > 0 && (
              <Pagination
                page={pagination.page}
                totalPages={pagination.totalPages}
                setPage={setPage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Hotelfeedback;
